module.exports = __webpack_public_path__ + "assets/img/101301.bbd0bd83.png";